import { ErrorViewModel }                       from '../../..';
import { ConversationSessionEntity,
         NotificationEntity }                   from '../..';

export interface IConversationState {
  /** Indicates whether the chatbot widget has a request in progress or not */
  isLoading: boolean;
  /** Indicates whether the chatbot widget has a satisfaction request in progress or not */
  isSatReqLoading: boolean;
  /** Indicates whether latest chatbot widget's request is succeed  */
  isRequestSucceed: boolean;
  /** The logged user entity instance */
  currentConversation?: ConversationSessionEntity;
  /** The previous conversations */
  history?: Map<string, ConversationSessionEntity>;
  /** The latest action error result asssociated to the current state */
  error?: ErrorViewModel;
 /** The count of notifications in the notification badge */
  notifications: NotificationEntity[];
}

export const ConversationDefaultState = (): IConversationState => {
  return {
    isLoading: false,
    isSatReqLoading: false,
    isRequestSucceed: false,
    currentConversation: undefined,
    history: undefined,
    error: undefined,
    notifications:[]
  };
};
